import styled from 'styled-components';
import { colors } from '../../globalStyles';

// TODO Add disabled style

export const Button = styled.button({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '5px 5px 5px 0px',
  minWidth: '240px',
  height: '30px',
  minHeight: 'fit-content',
  textAlign: 'center',
  border: `1px solid ${colors.darkGreen}`,
  borderRadius: '30px',
  padding: '0px 10px',
  backgroundColor: colors.darkGreen,
  color: colors.white,
  fontSize: '14px',
  cursor: 'pointer',
  fontWeight: 500,
  outline: 'none',
  '&:hover': {
    opacity: 0.8,
  },
  '@media only screen and (min-width: 944px)': {
    minWidth: '280px',
    height: 'auto',
    padding: '5px 10px',
  },

  '&:disabled': {
    cursor: 'not-allowed',
  },
});

export const ButtonSmall = styled(Button as any)({
  minWidth: '150px',
});

export const ButtonExtraSmall = styled(Button as any)({
  minWidth: 'fit-content',
});

export const ButtonExtraMargin = styled(Button as any)({
  marginTop: '15px',
  marginBottom: '15px',
  borderRadius: '5px',
  width: '80%',
  '@media only screen and (max-width: 944px)': {
    width: '100%',
    margin: '15px 0px',
  },
});

export const ButtonGray = styled(Button as any)({
  backgroundColor: colors.lightGray,
  color: colors.dark,
  border: 'none',
});
